import { render, staticRenderFns } from "./DocResource.vue?vue&type=template&id=55dd25c1&scoped=true&"
import script from "./DocResource.vue?vue&type=script&lang=js&"
export * from "./DocResource.vue?vue&type=script&lang=js&"
import style0 from "./DocResource.vue?vue&type=style&index=0&id=55dd25c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dd25c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
